module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('section', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('Logo', {
    attrs: {
      "width": 120,
      "height": 116
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('section', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', [_vm._v("Copyright © " + _vm._s(_vm.year) + " Pencils for Kids, Inc.")]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/#donate"
    }
  }, [_vm._v("Donate")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/our-story"
    }
  }, [_vm._v("Our Story")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/#events"
    }
  }, [_vm._v("Events")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/gallery"
    }
  }, [_vm._v("Gallery")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/our-team"
    }
  }, [_vm._v("Our Team")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/#contact"
    }
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address"
  }, [_c('strong', [_vm._v("Pencils for Kids, Inc.")]), _c('br'), _vm._v("\n          11 Mission Palms Drive West"), _c('br'), _vm._v("\n          Rancho Mirage, CA 92270 USA\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("Phone:")]), _vm._v(" +1 323-595-1693"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Email:")]), _vm._v(" info@pencilsforkidsinc.com"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("EIN")]), _vm._v(" 26-053134\n           \n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8ab151c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/SiteFooter.vue
// module id = 399
// module chunks = 2